export interface JournalistRow {
  id: number;
  canonical_name: string;
  primary_outlet: string | null;
  nationality_code: string | null;
  nationality_inferred: string | null;
  triage_tier: number | null;
  has_vietnam_coverage: number;
  vietnam_articles_count: number;
}

export interface QueueArticleRow {
  id: number;
  title: string | null;
  url: string;
  outlet: string | null;
  fetch_status: string;
  publish_date: string | null;
}

export interface CostSummary {
  provider: string;
  calls: number;
  total_cost_usd: number;
}

export interface StaffStatusRow {
  outlet: string;
  tier_rank: number;
  last_fetched_at: number | null;
  parsed_journalists_count: number | null;
}

async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(path, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`Request failed: ${response.status}`);
  return response.json() as Promise<T>;
}

export const api = {
  journalists: () => getJson<{ rows: JournalistRow[]; total: number }>('/api/journalists'),
  articleQueue: () => getJson<{ rows: QueueArticleRow[] }>('/api/article-queue'),
  costDashboard: () => getJson<{ rows: CostSummary[]; total_cost_usd: number }>('/api/cost-dashboard'),
  manualReview: () => getJson<{ rows: JournalistRow[] }>('/api/manual-review'),
  staffStatus: () => getJson<{ rows: StaffStatusRow[] }>('/api/staff-status')
};
